export const colors = {
  transparent: "transparent",
  // themeMainColor: "#0E5B18",
  subPrimary: "#FCAF17",
  tableColor: "#F8F9FB",
  tabColor: "#121D39",
  themeMainColor: "#4A4A4A",
  themeSecondColor: "#E46E2F",
  themeMainColorTwo: "#FF8000",
  themeMainColorThree: "#9E640E",
  themeThirdColor: "#DCFFEE",
  paleBlue: "#d8e8f4",
  themeResetColor: "#FC8F8F",
  statusActiveColor: "#1CB99A",
  statusInactiveColor: "#B00020",
  themeMainColorFour: "#FFF9F1",
  borderHeaderCard: "#f3f1f1",
  blueadminfade: "#14378A0D",
  textNormal: "#4A4A4A",
  approve: "#0A77FF",
  send_back: "#EEA23E",
  alert: "#D78100",
  complete: "#2AA63C",
  csv: "#217931",
  failed: "#C8322B",
  reject: "#E80000",
  fontAlert: "#EEA23E",
  fontComplete: "#2AA63C",
  fontFailed: "#C8322B",
  /** ! BG_COLORS */
  bgMainColor: "#29302E",
  bgSecondColor: "#1CB99A1A",
  white: "#ffffff",
  black: "#000000",
  bgBase: "#F3FFF6",
  green: "#5AA900",
  lightGreen: "#2EBF43",
  success3: "#0F9F0C",
  red: "#B00020",
  lightGrayMg: "#525D6A",
  brown: "#29302E",
  c: "#f1f9ff",
  blueDraft: "#2186E3",
  blue: "#007bff",
  sky: "#469acc",
  indigo: "#6610f2",
  purple: "#6f42c1",
  pink: "#e83e8c",
  orange: "#fd7e14",
  lightOrange: "#F0B760",
  darkOrange: "#EA4D2C",
  yellow: "#ffc107",
  lightYellow: "#FFF7D4",
  teal: "#20c997",
  cyan: "#17a2b8",
  extraLightGray: "#f5f5f5",
  lightGray: "#e5e5e5",
  disabledLightGray: "#c5c5c5",
  disabledGray: "#9e9e9e",
  gray: "#6c757d",
  darkGray: "#343a40",
  primary: "#0E5b18",
  secondary: "#E46E2F",
  success: "#28a745",
  lightSuccess: "#68BB86",
  info: "#17a2b8",
  warning: "#f88f41",
  darkWarning: "#e67e22",
  danger: "#dc3545",
  light: "#f8f9fa",
  dark: "#343a40",
  lightGrayBG: "#f8f8f8",
  bgModal: "#F0F0F0",
  bgNoti: "#FFFAF2",
  bgNoti1: "#F3FFF6",
  bgNoti2: "#FFEFEE",
  placeholder: "#DDE1EB",
  placeholder2: "#F2F4F7",

  // opacity
  white_30: "rgba(255, 255, 255, 0.3)",
  white_70: "rgba(255, 255, 255, 0.7)",
  white_80: "rgba(255, 255, 255, 0.8)",
  white_90: "rgba(255, 255, 255, 0.9)",
  black_05: "rgba(0, 0, 0, 0.05)",
  black_08: "rgba(0, 0, 0, 0.08)",
  black_10: "rgba(0, 0, 0, 0.10)",
  black_12: "rgba(0, 0, 0, 0.12)",
  black_16: "rgba(0, 0, 0, 0.16)",
  black_20: "rgba(0, 0, 0, 0.2)",
  black_25: "rgba(0, 0, 0, 0.25)",
  black_30: "rgba(0, 0, 0, 0.3)",
  black_60: "rgba(0, 0, 0, 0.6)",
  green_06: "rgba(28, 185, 154, 0.06)",
  green_10: "rgba(28, 185, 154, 0.1)",
  green_30: "rgba(28, 185, 154, 0.3)",
  red_10: "rgba(176, 0, 32, 0.1)",
  gray_06: "rgba(47, 66, 105, 0.06)",

  filterDropdown:
    "linear-gradient(to bottom, rgba(255, 255, 255, 0.53), rgba(242, 242, 242, 0.34))",

  // text
  textInput: "#666666",
  textGray: "#858C95",
  textExtraLightGray: "#929292",
  textLightGray: "#525D6A",
  textPrimary: "#29302E",
  bgText: "#D9D9D9",
  remember: "#323539",
  /** INPUT */
  borderInput: "#E5E5E7",
  inputProps: "#00000099",
  inputLabelProps: "#00000099",

  borderGray: "#E5E5E7",

  text: "#1B1F23",
  regisText: "#434855",

  divider: "rgb(94, 94, 94)",

  /** HEADER */
  headerBackground: "#0080600D",
  dropdown_button: "#4198E9",
};
